import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLocationModal } from "@/contexts/LocationModalProvider";
import { useLoginModal } from "@/contexts/LoginModalProvider";
import { useSearch } from "@/contexts/SearchProvider";

export default function Layout() {
  const { open: openLocationModal } = useLocationModal();
  const { open: openLoginModal } = useLoginModal();
  const { activateSearch, deactivateSearch, isSearchActive } = useSearch();

  return (
    <div className="h-full flex flex-col">
      <Navbar />
      <main
        className="flex-1"
        onClick={() => {
          deactivateSearch();
        }}
      >
        <div
          className={`h-full ${
            isSearchActive ? "blur-sm pointer-events-none" : ""
          }`}
        >
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
